import { createContext, useContext, useState, useEffect } from 'react';

// Language Context
const LanguageContext = createContext();

// Translations
export const translations = {
  he: {
    // Header
    nav: {
      home: "ראשי",
      about: "אודות",
      treatments: "טיפולים",
      results: "תוצאות",
      testimonials: "המלצות",
      contact: "צור קשר",
      bookConsultation: "לתיאום ייעוץ"
    },
    // Hero
    hero: {
      badge: "40+ שנות ניסיון מוכח",
      title: "הצלקת לא חייבת להיות חלק ממך לתמיד",
      subtitle: "מזל גניאל, מומחית פרא-רפואית בירושלים עם 40 שנות ניסיון, מציעה טיפולים מתקדמים לשיפור משמעותי במראה הצלקות",
      cta1: "לתיאום ייעוץ חינם",
      cta2: "למידע נוסף",
      trustBar: {
        experience: "שנות ניסיון",
        clients: "לקוחות מרוצים",
        success: "אחוזי הצלחה"
      }
    },
    // Pain Section
    pain: {
      title: "האם גם את/ה מרגיש/ה ככה?",
      items: [
        { title: "מתביישים בצלקת?", desc: "נמנעים מלבישת בגדים מסוימים או מפעילויות בגלל הצלקת" },
        { title: "ניסיתם הכל?", desc: "עברתם טיפולים שונים ללא תוצאות משמעותיות" },
        { title: "מרגישים חסרי תקווה?", desc: "חושבים שאין פתרון ושהצלקת תישאר איתכם לתמיד" }
      ],
      cta: "יש פתרון — בואו נדבר"
    },
    // Quote
    quote: {
      text: "״כל צלקת מספרת סיפור, אבל היא לא חייבת להגדיר אותך״",
      author: "— מזל, קוסמטיקאית פרא-רפואית"
    },
    // About
    about: {
      label: "הכירו את מזל",
      title: "40 שנה — לא סתם מספר",
      paragraphs: [
        "מזל גניאל היא קוסמטיקאית פרא-רפואית בכירה עם ניסיון של למעלה מ-40 שנה בטיפול בצלקות מורכבות. הקליניקה שלה ממוקמת בפסגת זאב, ירושלים.",
        "לאורך הקריירה שלה, מזל טיפלה באלפי לקוחות מירושלים והסביבה עם מגוון רחב של צלקות - מכוויות קשות ועד צלקות ניתוחיות.",
        "הגישה הייחודית שלה משלבת טכניקות מתקדמות עם יחס אישי וחם, תוך התאמת תוכנית טיפול אישית לכל לקוח."
      ],
      cta: "לתיאום ייעוץ חינם",
      yearsExperience: "שנות ניסיון"
    },
    // Treatments
    treatments: {
      label: "הטיפולים שלנו",
      title: "מגוון הטיפולים",
      subtitle: "כל טיפול מותאם אישית לצרכייך ולסוג עורך",
      items: [
        { title: "טיפולי פנים", description: "טיפולי פנים מקצועיים המותאמים לסוג העור ולצרכים האישיים. מנקים, מזינים ומחדשים את העור.", tag: "עור הפנים" },
        { title: "מיזותרפיה", description: "טכניקה צרפתית מתקדמת להזרקת ויטמינים וחומצה היאלורונית. מחדשת רקמות ומעוררת קולגן.", tag: "חידוש רקמות" },
        { title: "אפילציה", description: "הסרת שיער מקצועית בשיטות המתקדמות ביותר, המותאמות לסוג העור ולרגישותו.", tag: "הסרת שיער" },
        { title: "איפור קבוע", description: "עיצוב גבות, ריפוד שפתיים ותחרת עיניים. תוצאות עמידות עם מגע אישי ומדויק.", tag: "פרא-רפואי" },
        { title: "לייזר גוף", description: "טיפולי לייזר מתקדמים לשיפור מרקם העור והחלקת אי-סדירויות עוריות. הכל נעשה בעזרת מכשירים מתקדמים וטכנולוגיה חדישה.", tag: "טכנולוגיה מתקדמת" },
        { title: "עיצוב גבות", description: "עיצוב מקצועי בשיטת החוט ושעווה להגדרה מושלמת בהתאם לצורת הפנים.", tag: "עיצוב פנים" },
        { title: "הסרת שומות וסרחי עור", description: "הסרה בטוחה ומקצועית של שומות, סרחי עור ונגעים שפירים בשיטות מתקדמות ובליווי אישי.", tag: "טיפולי עור" }
      ],
      moreInfo: "לפרטים נוספים",
      sectionCta: "לא בטוחים איזה טיפול מתאים לכם?",
      sectionCtaButton: "התייעצו איתנו"
    },
    // Results
    results: {
      label: "תוצאות",
      title: "לפני ואחרי",
      subtitle: "תוצאות אמיתיות של לקוחות מרוצים",
      before: "לפני",
      after: "אחרי",
      cases: ["צלקת כוויה", "צלקת ניתוח", "צלקת אקנה"],
      disclaimer: "* התוצאות משתנות מאדם לאדם",
      cta: "רוצים תוצאות דומות?",
      ctaButton: "דברו איתנו"
    },
    // Process
    process: {
      label: "איך זה עובד?",
      title: "המסע שלך לעור חדש",
      steps: [
        { title: "יצירת קשר", desc: "התקשרו או שלחו הודעה" },
        { title: "ייעוץ ראשוני חינם", desc: "פגישת הכרות והערכה" },
        { title: "תוכנית טיפול אישית", desc: "בניית מסלול מותאם" },
        { title: "תוצאות", desc: "שיפור משמעותי בצלקת" }
      ]
    },
    // Vision
    vision: {
      brandName: "מזל – אסתטיקה ויופי גני אל",
      label: "החזון שלי",
      statement: {
        title: "הצהרת החזון",
        text: "החזון שלי הוא להוות עבורך את הגשר המדויק בין מדע הקוסמטיקה הפרא-רפואית לבין הטיפול האישי והעוטף ביותר. אני מחויבת להעניק לך את הביטחון להקרין את היופי הטבעי והבריא שלך לעולם, דרך תוצאות מוכחות ושילוב של טכנולוגיה עם נשמה."
      },
      mission: {
        title: "המשימה שלי",
        text: "אני כאן כדי להעניק לך פתרונות אסתטיים מתקדמים המבוססים על אבחון קליני מעמיק. המשימה שלי היא לא רק לטפל בעורך, אלא ליצור שינוי אמיתי בתחושת הביטחון שלך. אני לא מתפשרת על פחות מהסטנדרטים הגבוהים ביותר של מקצועיות, בטיחות ואמינות בכל טיפול וטיפול."
      },
      values: {
        title: "הערכים שמנחים אותי",
        items: [
          { title: "דיוק פרא-רפואי", text: "אני מאמינה בתוצאות. אני בוחרת כל תכשיר ומכשיר בקפידה על סמך מחקר ויעילות קלינית מוכחת." },
          { title: "התאמה אישית עמוקה", text: "עבורי, את לא ׳עוד לקוחה׳. אני רואה אותך, מקשיבה לצרכים שלך ובונה עבורך תוכנית טיפול ייחודית שמתאימה רק לך." },
          { title: "העצמה דרך יופי", text: "יופי עבורי הוא השתקפות של הרגשה פנימית. אני פועלת כדי שתרגישי הגרסה הטובה ביותר של עצמך בכל פעם שאת יוצאת מהדלת שלי." },
          { title: "למידה וחדשנות", text: "אני מקפידה להתעדכן ללא הרף בחידושים האחרונים בעולם הדרמטולוגיה והקוסמטיקה המדעית כדי להביא לך את הטוב ביותר." }
        ]
      },
      promise: {
        title: "ההבטחה שלי אלייך",
        quote: "הידע המקצועי שלי, הלב של המכון שלי.",
        text: "אני מבטיחה לך מרחב בטוח שבו המדע פוגש מגע אנושי וחם. אני כאן כדי להעניק לעור שלך בדיוק את מה שהוא צריך כדי לזרוח – בביטחון מלא ובתוצאות שנראות לעין."
      }
    },
    // Stats
    stats: {
      experience: "שנות ניסיון",
      clients: "לקוחות מרוצים", 
      success: "אחוזי הצלחה"
    },
    // Testimonials
    testimonials: {
      label: "מה אומרים עלינו",
      title: "לקוחות מספרים",
      items: [
        { name: "שרה כ.", city: "תל אביב", text: "״אחרי 20 שנה עם צלקת כוויה ביד, סוף סוף אני יכולה ללבוש שרוולים קצרים. מזל היא קסמית!״" },
        { name: "דוד מ.", city: "ירושלים", text: "״הגעתי עם צלקת מניתוח שהפריעה לי מאוד. אחרי 6 טיפולים - ההבדל מדהים. תודה מזל!״" },
        { name: "מיכל ר.", city: "חיפה", text: "״סבלתי מצלקות אקנה קשות. מזל החזירה לי את הביטחון העצמי. ממליצה בחום!״" },
        { name: "יוסי א.", city: "באר שבע", text: "״מקצועית, אכפתית ובעיקר - תוצאות. לא האמנתי שאפשר לשפר ככה צלקת בת 15 שנה.״" },
        { name: "רונית ל.", city: "נתניה", text: "״הטיפולים של מזל שינו לי את החיים. סוף סוף אני לא מתביישת בצלקת שלי.״" },
        { name: "אבי ש.", city: "פתח תקווה", text: "״40 שנות ניסיון זה לא סתם - רואים את זה בכל טיפול. מקצוענית אמיתית.״" }
      ]
    },
    // FAQ
    faq: {
      label: "שאלות נפוצות",
      title: "יש לכם שאלות?",
      items: [
        { q: "איפה נמצאת הקליניקה של מזל גניאל?", a: "הקליניקה ממוקמת ברחוב חיים גבריהו 11, פסגת זאב, ירושלים. נגישה בקלות מכל רחבי ירושלים, נווה יעקב, רמות, גבעת זאב, מעלה אדומים ובית שמש. חניה נוחה במקום." },
        { q: "כמה טיפולים נדרשים עד לתוצאה?", a: "מספר הטיפולים משתנה בהתאם לסוג הצלקת, גודלה וגילה. בדרך כלל נדרשים בין 4-12 טיפולים. בפגישת הייעוץ הראשונית נוכל לתת הערכה מדויקת יותר." },
        { q: "האם הטיפול כואב?", a: "הטיפולים שלנו מבוצעים בעדינות מרבית. רוב המטופלים מדווחים על אי נוחות קלה בלבד. אנו משתמשים בטכניקות מתקדמות למזעור אי הנוחות." },
        { q: "מה ההבדל בין טיפול פרא-רפואי לטיפול רפואי?", a: "טיפול פרא-רפואי מתמקד בשיפור מראה העור באמצעות טכניקות לא פולשניות, ללא ניתוח או תרופות. זהו טיפול בטוח עם תוצאות מוכחות ותקופת החלמה מינימלית." },
        { q: "כמה זמן עד שרואים שינוי?", a: "תוצאות ראשוניות נראות כבר אחרי 2-3 טיפולים. תוצאות מיטביות מושגות לאורך זמן, כאשר העור ממשיך להשתפר גם בין הטיפולים." },
        { q: "האם כל סוג של צלקת ניתן לטיפול?", a: "אנו מטפלים במגוון רחב של צלקות - כוויות, ניתוחים, פצעים, אקנה, קלואידים ועוד. בפגישת הייעוץ נבחן את הצלקת ונקבע את תוכנית הטיפול המתאימה." },
        { q: "מה עלות הטיפול?", a: "העלות משתנה בהתאם לסוג הטיפול והיקפו. בפגישת הייעוץ החינמית נבנה תוכנית טיפול אישית עם הצעת מחיר מפורטת. אנו מציעים גם אפשרויות תשלום נוחות." }
      ],
      cta: "עוד שאלות?",
      ctaButton: "דברו איתנו"
    },
    // Contact
    contact: {
      label: "צור קשר",
      title: "מוכנים להתחיל?",
      subtitle: "צרו קשר היום לייעוץ ראשוני חינם",
      form: {
        name: "שם מלא",
        namePlaceholder: "הכנס/י את שמך",
        phone: "מספר טלפון",
        phonePlaceholder: "050-0000000",
        scarType: "סוג הצלקת",
        scarTypePlaceholder: "בחרו סוג צלקת",
        message: "הודעה (אופציונלי)",
        messagePlaceholder: "ספרו לנו קצת על הצלקת...",
        submit: "שלחו הודעה",
        submitting: "שולח...",
        required: "*"
      },
      scarTypes: ["צלקת ניתוחית", "צלקת כוויה", "צלקות אקנה", "צלקת היפרטרופית", "קלואיד", "צלקת מפציעה", "אחר"],
      success: {
        title: "תודה! קיבלנו את פנייתך",
        message: "נחזור אליכם תוך 24 שעות."
      },
      info: {
        phone: "טלפון",
        whatsapp: "וואטסאפ",
        whatsappText: "שלחו הודעה",
        email: "אימייל"
      }
    },
    // Footer
    footer: {
      description: "קוסמטיקאית פרא-רפואית בכירה בירושלים, פסגת זאב. 40 שנות ניסיון בטיפול צלקות מורכבות. משרתת את ירושלים והסביבה.",
      quickLinks: "קישורים מהירים",
      contact: "יצירת קשר",
      rights: "כל הזכויות שמורות",
      legal: {
        privacy: "מדיניות פרטיות",
        terms: "תנאי שימוש",
        cookies: "מדיניות עוגיות",
        accessibility: "הצהרת נגישות"
      }
    },
    // AI Chat
    aiChat: {
      buttonLabel: "יועצת AI — שאלי אותי",
      header: "יועצת AI של מזל",
      subtitle: "זמינה 24/7",
      disclaimer: "המידע שמסופק כאן הוא לצרכי מידע כללי בלבד. אינו מהווה תחליף לייעוץ, אבחון או המלצת טיפול על ידי מומחה מנוסה.",
      consentTitle: "לפני שנתחיל...",
      consentText: "אני מבין/ה שהיועצת AI מספקת מידע כללי בלבד ואינה תחליף לייעוץ מקצועי.",
      consentButton: "הבנתי, המשך",
      inputPlaceholder: "כתבי הודעה...",
      greeting: "שלום! אני יועצת ה-AI של מזל 👋\n\nאני יכולה לענות על שאלות כלליות על טיפולי צלקות.\n\n⚠️ חשוב לדעת: המידע שלי הוא כללי בלבד ואינו תחליף לאבחון ועצה של מזל — קוסמטיקאית פרא-רפואית עם 40 שנות ניסיון.\n\nבמה אוכל לעזור?",
      quickReplies: ["סוגי צלקות", "כמה זמן טיפול?", "האם זה כואב?", "לתיאום פגישה"],
      footer: "נשלח על ידי מזל AI ✨",
      escalation: {
        title: "נשמע שמדובר במשהו שדורש תשומת לב מיידית. אני ממליצה לפנות ישירות למזל עכשיו:",
        call: "התקשרי",
        whatsapp: "WhatsApp",
        emergency: "אם מדובר בדחיפות רפואית — פנה/י לחדר מיון."
      }
    },
    // Feedback
    feedback: {
      buttonLabel: "משוב על האתר",
      title: "משוב על האתר",
      intro: "נשמח לשמוע את דעתך על האתר החדש! המשוב שלך יעזור לנו לשפר ולהתאים אותו בצורה הטובה ביותר.",
      ratingLabel: "איך היית מדרגת את האתר?",
      ratingTexts: ["צריך שיפור", "לא רע", "בסדר", "טוב מאוד", "מעולה!"],
      categoryLabel: "על מה המשוב? (אופציונלי)",
      categories: ["עיצוב ומראה", "תוכן וטקסטים", "ניווט ונוחות", "תמונות", "אחר"],
      textLabel: "ספרי לנו מה את חושבת",
      textPlaceholder: "מה אהבת? מה אפשר לשפר? יש משהו שחסר?",
      quickLabel: "או בחרי תגובה מהירה:",
      quickOptions: ["האתר נראה מקצועי", "קל לנווט", "התמונות יפות", "צריך יותר מידע", "הטקסטים ברורים"],
      submit: "שליחת משוב",
      submitting: "שולח...",
      successTitle: "תודה רבה!",
      successMessage: "המשוב שלך התקבל ויעזור לנו לשפר את האתר",
      close: "סגור"
    },
    // Cookie Banner
    cookies: {
      message: "אנו משתמשים בעוגיות כדי לשפר את חווית הגלישה שלך.",
      accept: "אישור",
      settings: "הגדרות",
      learnMore: "למידע נוסף"
    },
    // Accessibility
    accessibility: {
      title: "הגדרות נגישות",
      fontSize: "גודל טקסט",
      highContrast: "ניגודיות גבוהה",
      readableFont: "גופן קריא",
      highlightLinks: "הדגשת קישורים",
      reduceMotion: "הפחתת אנימציות",
      largeCursor: "סמן גדול",
      reset: "איפוס הגדרות",
      statement: "הצהרת נגישות"
    },
    // Mobile Bar
    mobileBar: {
      call: "התקשרו",
      whatsapp: "וואטסאפ"
    },
    // Exit Popup
    exitPopup: {
      title: "רגע לפני שאת/ה עוזב/ת...",
      subtitle: "האם ידעת שייעוץ ראשוני הוא ללא עלות?",
      description: "השאירו פרטים ונחזור אליכם תוך 24 שעות",
      cta: "לייעוץ חינם",
      dismiss: "אולי אחר כך"
    }
  },
  en: {
    // Header
    nav: {
      home: "Home",
      about: "About",
      treatments: "Treatments",
      results: "Results",
      testimonials: "Testimonials",
      contact: "Contact",
      bookConsultation: "Book Consultation"
    },
    // Hero
    hero: {
      badge: "40+ Years of Proven Experience",
      title: "Your Scar Doesn't Have to Define You Forever",
      subtitle: "Mazal Ganeel, a senior paramedical specialist in Jerusalem with 40 years of experience, offers advanced treatments for significant scar improvement",
      cta1: "Book Free Consultation",
      cta2: "Learn More",
      trustBar: {
        experience: "Years Experience",
        clients: "Happy Clients",
        success: "Success Rate"
      }
    },
    // Pain Section
    pain: {
      title: "Do You Feel This Way Too?",
      items: [
        { title: "Embarrassed by your scar?", desc: "Avoiding certain clothes or activities because of your scar" },
        { title: "Tried everything?", desc: "Been through various treatments without significant results" },
        { title: "Feeling hopeless?", desc: "Think there's no solution and the scar will stay forever" }
      ],
      cta: "There's a solution — let's talk"
    },
    // Quote
    quote: {
      text: "\"Every scar tells a story, but it doesn't have to define you\"",
      author: "— Mazal, Scar Treatment Specialist"
    },
    // About
    about: {
      label: "Meet Mazal",
      title: "40 Years — Not Just a Number",
      paragraphs: [
        "Mazal Ganeel is a senior paramedical specialist based in Pisgat Zeev, Jerusalem, with over 40 years of experience treating complex scars.",
        "Throughout her career, Mazal has treated thousands of clients from Jerusalem and the surrounding area with a wide variety of scars - from severe burns to surgical scars.",
        "Her unique approach combines advanced techniques with personal, warm care, tailoring a personalized treatment plan for each client."
      ],
      cta: "Book Free Consultation",
      yearsExperience: "Years Experience"
    },
    // Treatments
    treatments: {
      label: "Our Treatments",
      title: "Treatment Options",
      subtitle: "Each treatment is personally tailored to your needs and skin type",
      items: [
        { title: "Facial Treatments", description: "Professional facial treatments tailored to your skin type and personal needs. Cleanse, nourish and rejuvenate your skin.", tag: "Facial Skin" },
        { title: "Mesotherapy", description: "Advanced French technique for injecting vitamins and hyaluronic acid. Regenerates tissues and stimulates collagen.", tag: "Tissue Renewal" },
        { title: "Epilation", description: "Professional hair removal using the most advanced methods, suited to your skin type and sensitivity.", tag: "Hair Removal" },
        { title: "Permanent Makeup", description: "Eyebrow shaping, lip liner and eyeliner. Long-lasting results with a personal, precise touch.", tag: "Paramedical" },
        { title: "Body Laser", description: "Advanced laser treatments for improving skin texture and smoothing skin irregularities. All performed using state-of-the-art equipment and cutting-edge technology.", tag: "Advanced Technology" },
        { title: "Eyebrow Shaping", description: "Professional shaping using thread and wax methods for perfect definition according to your face shape.", tag: "Facial Shaping" },
        { title: "Mole & Skin Tag Removal", description: "Safe and professional removal of moles, skin tags and benign lesions using advanced methods with personal care.", tag: "Skin Treatments" }
      ],
      moreInfo: "Learn More",
      sectionCta: "Not sure which treatment is right for you?",
      sectionCtaButton: "Consult With Us"
    },
    // Results
    results: {
      label: "Results",
      title: "Before & After",
      subtitle: "Real results from satisfied clients",
      before: "Before",
      after: "After",
      cases: ["Burn Scar", "Surgical Scar", "Acne Scar"],
      disclaimer: "* Results vary from person to person",
      cta: "Want similar results?",
      ctaButton: "Talk to Us"
    },
    // Process
    process: {
      label: "How It Works",
      title: "Your Journey to New Skin",
      steps: [
        { title: "Contact Us", desc: "Call or send a message" },
        { title: "Free Consultation", desc: "Initial meeting and assessment" },
        { title: "Personal Treatment Plan", desc: "Building a tailored program" },
        { title: "Results", desc: "Significant scar improvement" }
      ]
    },
    // Vision
    vision: {
      brandName: "Mazal — Aesthetics & Beauty Ganeel",
      label: "My Vision",
      statement: {
        title: "Vision Statement",
        text: "My vision is to serve as the precise bridge between the science of paramedical cosmetology and the most personal, nurturing care. I am committed to giving you the confidence to radiate your natural, healthy beauty to the world — through proven results and a fusion of technology with soul."
      },
      mission: {
        title: "My Mission",
        text: "I am here to provide you with advanced aesthetic solutions grounded in thorough clinical assessment. My mission is not merely to treat your skin, but to create a genuine transformation in your self-confidence. I never settle for anything less than the highest standards of professionalism, safety, and integrity in every single treatment."
      },
      values: {
        title: "My Core Values",
        items: [
          { title: "Paramedical Precision", text: "I believe in results. I select every product and device meticulously, based on research and proven clinical efficacy." },
          { title: "Deep Personalization", text: "To me, you are never 'just another client.' I see you, I listen to your needs, and I build a treatment plan that is uniquely yours." },
          { title: "Empowerment Through Beauty", text: "Beauty, to me, is a reflection of how you feel inside. I work to ensure you feel like the best version of yourself every time you walk out my door." },
          { title: "Learning & Innovation", text: "I am dedicated to staying at the forefront of the latest advances in dermatology and scientific cosmetology, so I can always bring you the very best." }
        ]
      },
      promise: {
        title: "My Promise to You",
        quote: "My professional expertise, the heart of my practice.",
        text: "I promise you a safe space where science meets a warm, human touch. I am here to give your skin exactly what it needs to glow — with complete confidence and results you can see."
      }
    },
    // Stats
    stats: {
      experience: "Years Experience",
      clients: "Happy Clients",
      success: "Success Rate"
    },
    // Testimonials
    testimonials: {
      label: "What People Say",
      title: "Client Stories",
      items: [
        { name: "Sarah K.", city: "Tel Aviv", text: "\"After 20 years with a burn scar on my arm, I can finally wear short sleeves. Mazal is magical!\"" },
        { name: "David M.", city: "Jerusalem", text: "\"I came with a surgical scar that bothered me greatly. After 6 treatments - the difference is amazing. Thank you Mazal!\"" },
        { name: "Michelle R.", city: "Haifa", text: "\"I suffered from severe acne scars. Mazal gave me back my self-confidence. Highly recommend!\"" },
        { name: "Joseph A.", city: "Beer Sheva", text: "\"Professional, caring and most importantly - results. I didn't believe it was possible to improve a 15-year-old scar this much.\"" },
        { name: "Ronit L.", city: "Netanya", text: "\"Mazal's treatments changed my life. Finally I'm not embarrassed by my scar.\"" },
        { name: "Avi S.", city: "Petah Tikva", text: "\"40 years of experience is not just a number - you can see it in every treatment. A true professional.\"" }
      ]
    },
    // FAQ
    faq: {
      label: "FAQ",
      title: "Have Questions?",
      items: [
        { q: "Where is Mazal Ganeel's clinic located?", a: "The clinic is located at 11 Chaim Gevriahu Street, Pisgat Zeev, Jerusalem. Easily accessible from all parts of Jerusalem, Neve Yaakov, Ramot, Givat Zeev, Ma'ale Adumim and Beit Shemesh. Convenient parking available." },
        { q: "How many treatments are needed for results?", a: "The number of treatments varies depending on the scar type, size and age. Usually 4-12 treatments are required. We can give a more accurate estimate in the initial consultation." },
        { q: "Is the treatment painful?", a: "Our treatments are performed with utmost gentleness. Most patients report only mild discomfort. We use advanced techniques to minimize any discomfort." },
        { q: "What's the difference between paramedical and medical treatment?", a: "Paramedical treatment focuses on improving skin appearance using non-invasive techniques, without surgery or medication. It's a safe treatment with proven results and minimal recovery time." },
        { q: "How long until I see changes?", a: "Initial results are visible after 2-3 treatments. Optimal results are achieved over time, as the skin continues to improve between treatments." },
        { q: "Can all types of scars be treated?", a: "We treat a wide variety of scars - burns, surgeries, wounds, acne, keloids and more. In the consultation we'll examine the scar and determine the appropriate treatment plan." },
        { q: "What does treatment cost?", a: "The cost varies depending on the type and scope of treatment. In the free consultation we'll build a personal treatment plan with a detailed quote. We also offer convenient payment options." }
      ],
      cta: "More questions?",
      ctaButton: "Talk to Us"
    },
    // Contact
    contact: {
      label: "Contact",
      title: "Ready to Start?",
      subtitle: "Contact us today for a free initial consultation",
      form: {
        name: "Full Name",
        namePlaceholder: "Enter your name",
        phone: "Phone Number",
        phonePlaceholder: "050-0000000",
        scarType: "Scar Type",
        scarTypePlaceholder: "Select scar type",
        message: "Message (optional)",
        messagePlaceholder: "Tell us about your scar...",
        submit: "Send Message",
        submitting: "Sending...",
        required: "*"
      },
      scarTypes: ["Surgical Scar", "Burn Scar", "Acne Scars", "Hypertrophic Scar", "Keloid", "Injury Scar", "Other"],
      success: {
        title: "Thank you! We received your inquiry",
        message: "We'll get back to you within 24 hours."
      },
      info: {
        phone: "Phone",
        whatsapp: "WhatsApp",
        whatsappText: "Send message",
        email: "Email"
      }
    },
    // Footer
    footer: {
      description: "Senior paramedical specialist in Jerusalem, Pisgat Zeev. 40 years of experience treating complex scars. Serving Jerusalem and surrounding areas.",
      quickLinks: "Quick Links",
      contact: "Contact",
      rights: "All rights reserved",
      legal: {
        privacy: "Privacy Policy",
        terms: "Terms of Use",
        cookies: "Cookie Policy",
        accessibility: "Accessibility Statement"
      }
    },
    // AI Chat
    aiChat: {
      buttonLabel: "AI Assistant — Ask Me",
      header: "Mazal's AI Assistant",
      subtitle: "Available 24/7",
      disclaimer: "The information provided here is for general information purposes only. It is not a substitute for advice, diagnosis or treatment recommendation by an experienced specialist.",
      consentTitle: "Before we begin...",
      consentText: "I understand that the AI assistant provides general information only and is not a substitute for professional advice.",
      consentButton: "I understand, continue",
      inputPlaceholder: "Type a message...",
      greeting: "Hello! I'm Mazal's AI assistant 👋\n\nI can answer general questions about scar treatments.\n\n⚠️ Important: My information is general only and is not a substitute for diagnosis and advice from Mazal — a specialist with 40 years of experience.\n\nHow can I help you?",
      quickReplies: ["Scar Types", "Treatment Duration?", "Is it Painful?", "Book Appointment"],
      footer: "Powered by Mazal AI ✨",
      escalation: {
        title: "This sounds like something that requires immediate attention. I recommend contacting Mazal directly:",
        call: "Call",
        whatsapp: "WhatsApp",
        emergency: "If this is a medical emergency — go to the emergency room."
      }
    },
    // Feedback
    feedback: {
      buttonLabel: "Website Feedback",
      title: "Website Feedback",
      intro: "We'd love to hear your thoughts on the new website! Your feedback will help us improve.",
      ratingLabel: "How would you rate the website?",
      ratingTexts: ["Needs improvement", "Not bad", "OK", "Very good", "Excellent!"],
      categoryLabel: "What's your feedback about? (optional)",
      categories: ["Design & Look", "Content & Text", "Navigation & Ease of Use", "Images", "Other"],
      textLabel: "Tell us what you think",
      textPlaceholder: "What did you like? What can be improved? Is something missing?",
      quickLabel: "Or choose a quick response:",
      quickOptions: ["Site looks professional", "Easy to navigate", "Great images", "Need more info", "Text is clear"],
      submit: "Submit Feedback",
      submitting: "Sending...",
      successTitle: "Thank you!",
      successMessage: "Your feedback was received and will help us improve the website",
      close: "Close"
    },
    // Cookie Banner
    cookies: {
      message: "We use cookies to improve your browsing experience.",
      accept: "Accept",
      settings: "Settings",
      learnMore: "Learn More"
    },
    // Accessibility
    accessibility: {
      title: "Accessibility Settings",
      fontSize: "Font Size",
      highContrast: "High Contrast",
      readableFont: "Readable Font",
      highlightLinks: "Highlight Links",
      reduceMotion: "Reduce Animations",
      largeCursor: "Large Cursor",
      reset: "Reset Settings",
      statement: "Accessibility Statement"
    },
    // Mobile Bar
    mobileBar: {
      call: "Call",
      whatsapp: "WhatsApp"
    },
    // Exit Popup
    exitPopup: {
      title: "Wait Before You Go...",
      subtitle: "Did you know the initial consultation is free?",
      description: "Leave your details and we'll get back to you within 24 hours",
      cta: "Free Consultation",
      dismiss: "Maybe Later"
    }
  }
};

// Language Provider Component
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('he');
  const [direction, setDirection] = useState('rtl');

  useEffect(() => {
    // Load saved language preference
    const saved = localStorage.getItem('siteLanguage');
    if (saved && (saved === 'he' || saved === 'en')) {
      setLanguage(saved);
      setDirection(saved === 'he' ? 'rtl' : 'ltr');
    }
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    setDirection(lang === 'he' ? 'rtl' : 'ltr');
    localStorage.setItem('siteLanguage', lang);
    
    // Update document direction
    document.documentElement.dir = lang === 'he' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, direction, changeLanguage, t, translations: translations[language] }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook to use language
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageProvider;
